// Testimonial data
export const TESTMONIAL1 = "AdSki transformed our outdated website into a modern, user-friendly platform. The design is sleek, fast, and optimized for conversions. Highly impressed with their creativity and professionalism!"
export const OWNER_NOVA = 'Rahul Mehta';
export const NOVA_DES = 'Founder of TechNova';

export const TESTMONIAL2 = "AdSki ran highly targeted Facebook & Instagram ads for our business, and the results were incredible! We saw a 3X increase in leads within weeks. Best decision we made!";
export const OWNER_TRENDY = 'Ankit Verma';
export const TRENDY_DES = 'Owner of TrendyKart';

export const TESTMONIAL3 = "AdSki's lead generation strategies helped us scale our business rapidly. With their targeted campaigns, we saw a 4X increase in qualified leads within a month! Their approach is data-driven and highly effective.";
export const OWNER_AMIR = 'Amir Khanna';
export const AMIR_DES = 'Founder of Luxe Interiors';

export const TESTMONIAL4 = "AdSki's social media marketing brought in more leads than we ever expected! Their Facebook & Instagram ad strategies helped us connect with the right audience & boost our conversions. Highly recommend their services!"
export const OWNER_SONIA = 'Sonia Malhotra';
export const SONIA_DES = 'Owner of FitGlow Wellness';

export const TESTMONIAL5 = "We struggled to get customers online until AdSki took over our Google Ads. Within weeks, our inquiries doubled, and we started getting consistent leads for our services. Their expertise in paid ads is truly remarkable!"
export const OWNER_VIKRAM = 'Vikram Joshi';
export const VIKRAM_DES = 'CEO of Elite Home Services';



export const FB = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="white">
<path d="M22.5 0h-21A1.5 1.5 0 0 0 0 1.5v21A1.5 1.5 0 0 0 1.5 24h21A1.5 1.5 0 0 0 24 22.5V1.5A1.5 1.5 0 0 0 22.5 0zM12 4.5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm3 12h-2v7h-4v-7h-2v-3h2v-2.5c0-2.3 1.2-3.5 3.3-3.5 1.3 0 2.7.2 2.7.2v3h-2c-1.2 0-1.5.7-1.5 1.4v2.1h3l-.5 3h-2.5v7z"/>
</svg>
export const INSTA = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="white"></svg>


// Form data
export const CONTACT_SUCESS_MSG = "Thank you for your message! We will get back to you soon.";
export const CONTACT_ERROR_MSG = "There was an error submitting the form. Please try again later.";

export const CONTACT_API_URL = "http://localhost:5000/api/create"; // Replace with your actual API URL
export const NAME_ERROR = "Name must be at least 3 characters long or Name must be less than 50 characters long.";
export const INVALID_EMAIL_ERROR = "Invalid email address";
export const ALL_FIELD_ERROR = "All fields are required.";
export const INVALID_MESSAGE_ERROR = "Message must be at least 5 characters long or Message must be less than 500 characters long.";
export const INVALID_MOBILE_LENGTH_ERROR = "Mobile number should be at least 10 digits long";
export const SERVICE_ERROR = "Please select a service";
export const CONTACT_FORM_URL = "https://api.web3forms.com/submit";
export const ACCESS_KEY = "9f86b3a3-98d2-49b2-852b-dfd189aa9bcf";
export const GREEN_TICK = <svg className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>

export const WHATSAPP_NUMBER = "6394731250";
export const Email = "info@adski.in"